export default "__VITE_ASSET__ee6b71f2__"